import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons/faEllipsisH';

import React from 'react';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { CustomsForm } from '../../../../../../src/containers/print-document-button-containers/order-details/components/customs-form';
import { Label } from '../../../../../../src/containers/print-document-button-containers/order-details/components/label';
import { OrderSummary } from '../../../../../../src/containers/print-document-button-containers/order-details/components/order-summary';
import { PackingSlip } from '../../../../../../src/containers/print-document-button-containers/order-details/components/packing-slip';
import { PickList } from '../../../../../../src/containers/print-document-button-containers/order-details/components/pick-list';
import { FulfillmentPropType } from '../../../../../prop-types/fulfillment';
import { FulfillmentPlanPropType } from '../../../../../prop-types/fulfillment-plan';
import style from './style.module.less';

export const ShipmentActionsMenu = ({ fulfillmentPlan, fulfillment = null }) => {
  const { fulfillmentPlanId } = fulfillmentPlan;
  return (
    <DropdownMenu className={style['actions-dropdown']}>
      <DropdownMenuToggler className={style['actions-toggler']} hideChevron theme='unstyled'>
        <FontAwesomeIcon className={style['shipment-actions']} icon={faEllipsisH} />
      </DropdownMenuToggler>
      {fulfillment && <CustomsForm fulfillmentIds={[fulfillment.fulfillmentId]} fulfillmentPlanIds={[fulfillmentPlanId]} />}
      {fulfillment && <Label fulfillments={[fulfillment]} userHasShippingRole />}
      <PickList fulfillmentPlanIds={[fulfillmentPlanId]} />
      <OrderSummary fulfillmentPlanIds={[fulfillmentPlanId]} />
      <PackingSlip fulfillmentPlanIds={[fulfillmentPlanId]} fulfillmentPlans={[fulfillmentPlan]} />
    </DropdownMenu>
  );
};

ShipmentActionsMenu.propTypes = {
  fulfillmentPlan: FulfillmentPlanPropType.isRequired,
  fulfillment: FulfillmentPropType,
};
